<div [agprLoading]="loading" [loadingSmallIndicator]="smallIndicator" #chartElement class="agpr-am5Chart"></div>
